import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TablePagination
} from '@mui/material';
import { cryptoAPI } from '../../Api';

const CryptoWalletsList = () => {
  // Main list state
  const [wallets, setWallets] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');

  // History dialog state
  const [historyDialogOpen, setHistoryDialogOpen] = useState(false);
  const [selectedHistory, setSelectedHistory] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState('');

  // Add wallet dialog state
  const [addDialogOpen, setAddDialogOpen] = useState(false);
  const [newAddress, setNewAddress] = useState('');
  const [newToken, setNewToken] = useState('BTC');

  useEffect(() => {
    fetchWallets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage, search]);

  const fetchWallets = async () => {
    try {
      const pageNum = page + 1;
      const limitNum = rowsPerPage;
      const response = await cryptoAPI.getWallets(pageNum, limitNum, search);
      setWallets(response.data.data);
      setTotal(response.data.pagination.total);
    } catch (error) {
      console.error('Error fetching wallets:', error);
    }
  };

  const handleSearchChange = (e) => setSearch(e.target.value);
  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const openHistoryDialog = (wallet) => {
    console.log('WALLET', wallet)
    setSelectedHistory(wallet.history || []);
    setSelectedAddress(wallet.address);
    setHistoryDialogOpen(true);
  };
  
  const deleteAddress = async (wallet) => {
    const confirmed = window.confirm('Вы уверены, что хотите удалить этот адрес?');
    if (confirmed) {
      await cryptoAPI.deleteWallet(wallet._id);
      fetchWallets();
      alert('Адрес удален');
      
    } else {
      alert('Удаление отменено');
    }
  };
  const handleAddWallet = async () => {
    try {
      await cryptoAPI.createWallet({ address: newAddress, token: newToken });
      setAddDialogOpen(false);
      setNewAddress('');
      setNewToken('BTC');
      fetchWallets();
    } catch (error) {
      console.error('Error creating wallet:', error);
    }
  };

  return (
    <>
      {/* История транзакций */}
      <Dialog
        open={historyDialogOpen}
        onClose={() => setHistoryDialogOpen(false)}
        maxWidth="60%"
        fullWidth
      >
        <DialogTitle>История кошелька: {selectedAddress}</DialogTitle>
        <DialogContent>
          <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>TXID</TableCell>
                  <TableCell>Сумма</TableCell>
                  <TableCell>Сумма до комиссии</TableCell>
                  <TableCell>Курс</TableCell>
                  <TableCell>Дата</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {selectedHistory.map((tx, idx) => (
                  <TableRow key={tx.txid || idx}>
                    <TableCell>{tx.txid}</TableCell>
                    <TableCell>{tx.btc} BTC</TableCell>
                    <TableCell>{tx.btc_no_fee} BTC</TableCell>
                    <TableCell>{tx.course || '-'} руб</TableCell>
                    <TableCell>{new Date(tx.datetime).toLocaleString('ru-RU')}</TableCell>
                    
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setHistoryDialogOpen(false)}>Закрыть</Button>
        </DialogActions>
      </Dialog>

      {/* Добавление нового кошелька */}
      <Dialog open={addDialogOpen} onClose={() => setAddDialogOpen(false)}>
        <DialogTitle>Добавить кошелек</DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <TextField
            label="Адрес"
            value={newAddress}
            onChange={(e) => setNewAddress(e.target.value)}
            fullWidth
          />
          <FormControl fullWidth>
            <InputLabel>Токен</InputLabel>
            <Select
              value={newToken}
              label="Токен"
              onChange={(e) => setNewToken(e.target.value)}
            >
              <MenuItem value="BTC">BTC</MenuItem>
              <MenuItem value="LTC">LTC</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAddDialogOpen(false)}>Отмена</Button>
          <Button onClick={handleAddWallet} disabled={!newAddress}>Добавить</Button>
        </DialogActions>
      </Dialog>

      {/* Основной экран с перечнем кошельков */}
      <Box sx={{ mt: 8, p: 4, boxShadow: 3, borderRadius: 2, bgcolor: '#fefcfb' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h5">Crypto кошельки</Typography>
          <Button variant="contained" onClick={() => setAddDialogOpen(true)}>
            Добавить кошелек
          </Button>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <TextField
            label="Поиск по адресу"
            variant="outlined"
            size="small"
            value={search}
            onChange={handleSearchChange}
            sx={{ minWidth: 240 }}
          />
        </Box>
        <TableContainer component={Paper} sx={{ boxShadow: 2 }}>
          <Table sx={{ minWidth: 650 }} aria-label="wallets table">
            <TableHead>
              <TableRow>
                <TableCell>Адрес</TableCell>
                <TableCell>Статус</TableCell>
                <TableCell>Токен</TableCell>
                <TableCell>Дата добавления</TableCell>
                <TableCell>Действия</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {wallets.length > 0 ? (
                wallets.map((wallet, idx) => (
                  <TableRow
                    key={wallet._id}
                    sx={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#f9fbfd', '&:hover': { backgroundColor: '#e3f0ff' } }}
                  >
                    <TableCell>{wallet.address}</TableCell>
                    <TableCell>{wallet.status}</TableCell>
                    <TableCell>{wallet.token}</TableCell>
                    <TableCell>{wallet.createdAt ? new Date(wallet.createdAt).toLocaleString('ru-RU') : '-'}</TableCell>
                    <TableCell>
                      <Button size="small" onClick={() => openHistoryDialog(wallet)}>
                        История
                      </Button>
                      <Button size="small" onClick={() => deleteAddress(wallet)}>
                        Удалить
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center">Нет кошельков</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={total}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              '& .MuiTablePagination-select': { color: '#683d62' },
              '& .MuiTablePagination-toolbar': { backgroundColor: '#fefcfb' },
              '& .MuiTablePagination-spacer': { display: 'none' },
              '& .MuiTablePagination-actions': { color: '#683d62' }
            }}
          />
        </TableContainer>
      </Box>
    </>
  );
};

export default CryptoWalletsList;